var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('a',{staticClass:"btn-save",on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_vm._v(_vm._s(_vm.$t("save")))]),_c('a',{staticClass:"btn-cancel",on:{"click":function($event){$event.preventDefault();return _vm.cancel()}}},[_vm._v(_vm._s(_vm.$t("cancel")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }